import type { UploadFile } from 'antd'

// pastedImageFiles extracts image files from a clipboard paste (screenshots,
// copied images) and wraps them as AntD UploadFile entries — status 'done',
// originFileObj set — ready to append to a controlled Upload fileList. The
// ticket reply submit then uploads each originFileObj via multipart, so pasting
// an image behaves exactly like attaching one, minus the detour through Paint.
//
// Returns [] when the clipboard holds no image (so a normal text paste is left
// untouched — do NOT preventDefault based on this alone). A pasted screenshot
// usually has no filename, so we synthesise a stable, human-readable one.
export function pastedImageFiles(
  data: DataTransfer | null | undefined,
): UploadFile[] {
  const items = data?.items
  if (!items) return []
  const out: UploadFile[] = []
  const stamp = Date.now()
  let i = 0
  for (const it of Array.from(items)) {
    if (it.kind !== 'file' || !it.type.startsWith('image/')) continue
    const file = it.getAsFile()
    if (!file) continue
    const ext = (file.type.split('/')[1] || 'png').toLowerCase().replace('jpeg', 'jpg')
    // Browsers hand pasted screenshots the generic name "image.png" (or none) —
    // give each a unique, sortable name so multiple pastes don't collide.
    const hasRealName = !!file.name && file.name.toLowerCase() !== 'image.png'
    const name = hasRealName ? file.name : `einfuegung-${stamp}-${i + 1}.${ext}`
    out.push({
      uid: `paste-${stamp}-${i}`,
      name,
      status: 'done',
      size: file.size,
      type: file.type,
      originFileObj: file as unknown as UploadFile['originFileObj'],
    })
    i++
  }
  return out
}
